import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="push-notifications"
export default class extends Controller {
  static values = {
    url: String,
    vapidPublicKey: String
  }

  togglePush(e) {
    if (e.target.checked) {
      this.subscribeDevice()
    } else {
      this.unsubscribeDevice()
    }
  }

  async subscribeDevice()  {
    try {
      switch (Notification.permission) {
        case 'denied':
          throw new Error('Push messages are blocked.');
        case 'granted':
          break;
        default:
          await new Promise((resolve, reject) => {
            Notification.requestPermission((result) => {
              if (result !== 'granted') {
                reject(new Error('Bad permission result'))
              }

              resolve()
            })
          })
      }

      // We need the service worker registration to access the push manager
      try {
        const reg = await navigator.serviceWorker.ready;
        const subscription = await reg.pushManager.subscribe(
          {
            userVisibleOnly: true,
            applicationServerKey: this.vapidPublicKeyValue
          }
        )

        await this.createSubscription(subscription)
      } catch (err) {
        console.error(err)
      }
    } catch (err) {
      console.error('subscribeDevice() ', err);
    }
  }

  async unsubscribeDevice() {
    try {
      const reg = await navigator.serviceWorker.ready
      const subscription = await reg.pushManager.getSubscription()

      if (!subscription) {
        await this.deleteSubscription()
        return;
      }

      const successful = await subscription.unsubscribe();
      if (!successful) {
        console.warn('We were unable to unregister from push')
      }

      await this.deleteSubscription()
    } catch (err) {
      console.error('Error thrown while revoking push notifications. ' +
        'Most likely because push was never registered', err);
    }
  }

  createSubscription(subscription) {
    return $.ajax({
      url: this.urlValue,
      data: JSON.stringify({ subscription: JSON.parse(JSON.stringify(subscription)) }),
      processData: false,
      contentType: 'application/json',
      dataType: 'json',
      type: 'POST',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content }
    })
  }

  deleteSubscription() {
    return $.ajax({
      url: this.urlValue,
      processData: false,
      contentType: 'application/json',
      dataType: 'json',
      type: 'DELETE',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content }
    })
  }
}
